import knowColorsToHex from "../converters/knowColorsToHex.js";
import RGBToHex from "../converters/RGBToHex.js";
import HSLToRGB from "../converters/HSLToRGB.js";

const swipeRegex = /!/;
const sameColorRegex = /\*/;

/**
 *
 * @param {string[]} color - in hex, rgb, hsl, know color format
 * @returns {string} hex color
 * @description this function will get color in hex, rgb, hsl, know color format and convert it to hex
 */
const syntaxCheckAndConvertToHex = (...color) => {
  if (!color) return null;
  let swipeTheme = false,
    sameColor = false;
  let retColor = "";
  let format = "rgb";
  let startIndex = 0;
  switch (color.length) {
    case 1:
      //hex or knownColor
      color = color[0].trim();
      swipeTheme = swipeRegex.test(color);
      sameColor = sameColorRegex.test(color);
      color = color.replace("*", "").replace("!", "");
      if (typeof color !== "string") return null;
      let kolor = knowColorsToHex(color);
      if (kolor) {
        retColor = kolor;
        break;
      }
      const hexFormatFull = /^#[0-9a-z]{6}$/gi;
      const hexFormatHalf = /^#[0-9a-z]{3}$/gi;
      color = color.startsWith("#") ? color : "#" + color;
      if (hexFormatFull.test(color) || hexFormatHalf.test(color))
        retColor = color;
      else return null;
      break;
    case 4:
      // swipeTheme = color[0].startsWith("!");
      swipeTheme = color[0].includes("!");
      sameColor = color[0].includes("*");
      if (color[0].includes("h")) format = "h";
      if (color[0].includes("r")) format = "r";
      startIndex = 1;
    case 3:
      //rgb or hsl
      if (format === "h") {
        color = HSLToRGB(
          color[startIndex],
          color[startIndex + 1],
          color[startIndex + 2]
        );
        startIndex = 0;
      }
      retColor = RGBToHex(
        color[startIndex],
        color[startIndex + 1],
        color[startIndex + 2]
      );
      break;
    default:
      return null;
  }
  return { hex: retColor, swipeTheme, sameColor };
};

export default syntaxCheckAndConvertToHex;
